import { createSlice } from '@reduxjs/toolkit';

import { CRUISE_LIST_SORT_ORDERS } from '../../../constants/sortOrders';
import { urlUtils } from '../../../utils/url';

import { initSucceeded } from '../../actions/cruiseListActions';

const sortKeyFromUrl = urlUtils.getSortKeyFromUrl();

const initialState = {
  selected: sortKeyFromUrl || CRUISE_LIST_SORT_ORDERS.DEPARTURE_DATE,
  sortOptions: [],
  sortPanelIsVisible: false,
};

// Both actions here are slice-generated: no thunk dispatches them. The URL write for
// `sortOrderSelected` lives in the query listener, not in this reducer — unlike package-plus-list,
// which has no middleware and writes from inside its reducer.
const sortSlice = createSlice({
  name: 'sort',
  initialState,
  reducers: {
    // The guard discards a re-pick of the current order, so no re-render happens. The listener
    // still writes the URL for the discarded dispatch, because it matches on the action rather
    // than on a state change. Both halves are pinned by tests.
    sortOrderSelected: (state, action) => {
      if (state.selected === action.payload) return;
      state.selected = action.payload;
    },
    sortPanelToggled: (state, action) => {
      state.sortPanelIsVisible = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initSucceeded, (state, action) => {
      const { labels } = action.payload;
      state.sortOptions = [
        { name: labels.sortLabelDepartureDate, value: CRUISE_LIST_SORT_ORDERS.DEPARTURE_DATE },
        { name: labels.sortLabelLowestPrice, value: CRUISE_LIST_SORT_ORDERS.LOWEST_PRICE },
        { name: labels.sortLabelHighestPrice, value: CRUISE_LIST_SORT_ORDERS.HIGHEST_PRICE },
        { name: labels.sortLabelDuration, value: CRUISE_LIST_SORT_ORDERS.DURATION },
      ];
    });
  },
});

export const { sortOrderSelected, sortPanelToggled } = sortSlice.actions;

export default sortSlice.reducer;
